/**
 * What: A small block shown in a section's status area while the Worker recalculates it: a progress icon and one
 *   phrase. Interaction is never disabled while it shows.
 * Transport / data-flow: Pure presentation. The phrase is the Worker's own word for the block the merchant edited, chosen
 *   by `resolveWorkingCues` (`workingPhrase.ts`); the component picks nothing.
 */
import './WorkingCue.css'

export function WorkingCue({ phrase }: { phrase: string }) {
  return (
    <div className="tf-working-cue">
      <s-stack direction="inline" alignItems="center" gap="small-200">
        <s-spinner size="base" accessibilityLabel={phrase} />
        <s-text color="subdued">{phrase}</s-text>
      </s-stack>
    </div>
  )
}
